import { FC } from 'react';

import { StyledRoot, StyledThumb } from './Switch.styled';
import type { SwitchProps } from './types';

const Switch: FC<SwitchProps> = ({
  checked,
  defaultChecked,
  onCheckedChange,
  name,
  value,
  disabled,
  readOnly,
  required,
  ariaLabel,
  size = 'md',
}) => (
  <StyledRoot
    checked={checked}
    defaultChecked={defaultChecked}
    onCheckedChange={onCheckedChange}
    name={name}
    value={value}
    disabled={disabled}
    readOnly={readOnly}
    required={required}
    aria-label={ariaLabel}
    $size={size}
  >
    <StyledThumb $size={size} />
  </StyledRoot>
);

Switch.displayName = 'Switch';

export default Switch;
